import { useTranslation } from 'react-i18next'

import { useLinkLikeClick } from '../../../../../hooks'
import Button from '../../../../Button'
import { PageEmptyState } from '../../../../PageEmptyState'
import { Table } from '../../../../Table'
import Text from '../../../../Text'
import { useListingProfileContext } from '../RentalPortalListingProfile.hooks'

import { ListingProfilePublishingsRow } from './ListingProfilePublishingsRow'
import {
  LISTING_PROFILE_PUBLISHINGS_SKELETON_ROWS,
  LISTING_PUBLICATION_COLUMNS_CONFIG,
  QA_NAME_LISTING_PROFILE_PUBLISHINGS_RETRY,
  QA_NAME_LISTING_PROFILE_PUBLISHINGS_TABLE,
} from './RentalPortalListingProfilePublishings.constants'
import {
  useListingProfilePublicationActions,
  useListingProfilePublicationsPoll,
} from './RentalPortalListingProfilePublishings.hooks'
import {
  getIsListingPublicationsEmpty,
  getIsListingPublicationsError,
  getIsListingPublicationsLoading,
  getListingPublicationRows,
  getListingPublicationsState,
} from './RentalPortalListingProfilePublishings.utils'

import * as styles from './RentalPortalListingProfilePublishings.module.css'

import RefreshIcon from '../../../../../icons/refresh.svg'
import RentalPortalIcon from '../../../../../icons/rental-portal.svg'

function RentalPortalListingProfilePublishings() {
  const { t } = useTranslation()

  const { handleEntityReload, isInitiated, isLoading, listingData } =
    useListingProfileContext()

  const { handleClick: handleLinkClick } = useLinkLikeClick()

  const { getActions, isLoadingPortals, portals, setItemAction } =
    useListingProfilePublicationActions()

  const publications = listingData?.portal_publications

  useListingProfilePublicationsPoll({
    isReloading: isLoading,
    publications,
    onPoll: handleEntityReload,
  })

  const rows = getListingPublicationRows({ portals, publications })

  const state = getListingPublicationsState({
    isInitiated,
    isLoadingPortals,
    publications,
    rows,
  })

  function handleClickRow(publication) {
    handleLinkClick({ link: publication.public_url, outsideLink: true })
  }

  return (
    <div className={styles.RentalPortalListingProfilePublishings}>
      {getIsListingPublicationsError(state) ? (
        <PageEmptyState EntityIcon={RentalPortalIcon}>
          <Text isSecondary>
            {t('RentalPortal.ListingProfilePublishingsLoadErrorKey')}
          </Text>
          <Button.Flat
            beforeIconProps={{ Icon: RefreshIcon }}
            isLoading={isLoading}
            qaName={QA_NAME_LISTING_PROFILE_PUBLISHINGS_RETRY}
            text={t('RentalPortal.ListingRetryBtnKey')}
            onClick={handleEntityReload}
          />
        </PageEmptyState>
      ) : getIsListingPublicationsEmpty(state) ? (
        <PageEmptyState
          EntityIcon={RentalPortalIcon}
          text={t('RentalPortal.ListingProfilePublishingsEmptyKey')}
        />
      ) : (
        <Table
          TableRow={ListingProfilePublishingsRow}
          actionsColumnWidth={0}
          columns={LISTING_PUBLICATION_COLUMNS_CONFIG}
          context={QA_NAME_LISTING_PROFILE_PUBLISHINGS_TABLE}
          headerRowProps={{ resizable: false }}
          isLoading={getIsListingPublicationsLoading(state)}
          items={rows}
          rowProps={{
            getPublicationActions: getActions,
            onCallAction: setItemAction,
            onClick: handleClickRow,
          }}
          skeletonProps={{ withCheckbox: false }}
          skeletonRows={LISTING_PROFILE_PUBLISHINGS_SKELETON_ROWS}
        />
      )}
    </div>
  )
}

export default RentalPortalListingProfilePublishings
